import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=f3708a54&scoped=true&"
import script from "./NewSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./NewSearch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3708a54",
  null
  
)

export default component.exports